import { render } from "./NewsReading.vue?vue&type=template&id=3014ae36&scoped=true"
import script from "./NewsReading.vue?vue&type=script&lang=js"
export * from "./NewsReading.vue?vue&type=script&lang=js"

import "./NewsReading.vue?vue&type=style&index=0&id=3014ae36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3014ae36"]])

export default __exports__